import { render, staticRenderFns } from "./elem-form-list.vue?vue&type=template&id=f1d9bc9e&"
import script from "./elem-form-list.vue?vue&type=script&lang=js&"
export * from "./elem-form-list.vue?vue&type=script&lang=js&"
import style0 from "./elem-form-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports